const queue_manager_labels = {
    IT: {
        // Breadcrumb Navigation
        home: "Home",
        queueManager: "Gestore Code",

        // Main Page
        queueManagerTitle: "Gestore Code",
        queueListTitle: "Lista Code",

        // Table Headers
        id: "Id",
        status: "Stato",
        errorCount: "Conteggio Errori",
        notBefore: "Non Prima Di",
        start: "Inizio",
        end: "Fine",

        // Table Data
        notStart: "Non avviato",
        inProgress: "In corso",

        // Modal
        listItemTitle: "Elemento Lista",
        actionDetail: "Dettaglio Azione",
        processStatusDetail: "Dettaglio Stato Processo",
        close: "Chiudi"
    },
    EN: {
        // Breadcrumb Navigation
        home: "Home",
        queueManager: "Queue Manager",

        // Main Page
        queueManagerTitle: "Queue Manager",
        queueListTitle: "Queue List",

        // Table Headers
        id: "Id",
        status: "Status",
        errorCount: "Error count",
        notBefore: "Not Before",
        start: "Start",
        end: "End",

        // Table Data
        notStart: "Not start",
        inProgress: "In progress",

        // Modal
        listItemTitle: "List item",
        actionDetail: "Action Detail",
        processStatusDetail: "Process Status Detail",
        close: "Close"
    }
};

const QueueManagerLabels = {
    it: queue_manager_labels.IT,
    en: queue_manager_labels.EN
};

export { QueueManagerLabels }; 